import api from "./api";
import md5 from "js-md5";

/** 与后端 appsettings ImgTokenSecret 保持一致 */
const IMG_TOKEN_SECRET = "ylwImgTk7K9mP2xQ4nR8vW3sL6hJ5f";

/**
 * 大数据 2020 12 28 -----------------------------------------------------------------------------
 */

// 养殖产量分布图
export const getAreaOutput = () => api.get(`/api/BigData/AreaOutput`, {});

// 30天销售额，今日销售额 ，最新成交价，基地数量，养殖面积，塘口数量
export const getRealTimeBaseAndSale = () =>
  api.get(`/api/BigData/RealTimeBaseAndSale`);

// 累计销售额+累计销量
export const getRealTimeTotal = () => api.get(`/api/BigData/RealTimeTotal`, {});

// 渔场物联网
export const getIotAreaCount = () =>
  api.get(`/api/BigData/GetIotAreaCount`, {});

// 渔联网总用户数
export const getUserCount = () => api.get(`/api/BigData/UserCount`, {});

// 鱼塘塘口面积
export const getPondAreaCount = () => api.get(`/api/BigData/PondAreaCount`, {});

// 养殖基地个数
export const getFishBaseCount = () => api.get(`/api/BigData/fishBaseCount`, {});

// 养殖类型占比
export const getCultivationTypeRate = () =>
  api.get(`/api/BigData/CultivationTypeRate`, {});

// 损失占比
export const getLossRate = () => api.get(`/api/BigData/LossRate`, {});

// 养殖品种
export const getBreedRate = () => api.get(`/api/BigData/BreedRate`, {});

// 当前公司名称
export const getCompanyName = () => api.get(`/api/Enterprise/Simple`, {});

//获取证书管理数据
export const getCertificate = () => api.get(`/api/Certificate`, {});

//修改证书管理数据
export const editCertificate = a => api.post(`/api/Certificate`, a);

// 绑定溯源码
export const bindQualityTracingCode = params =>
  api.post(`/api/TraceCode/AddTraceSubordCode`, params);

// 删除溯源码
export const deleteSubordCode = code =>
  api.delete(`/api/TraceCode/DelSubordCode?subcode=${code}`, {});

// 新增质检报告
export const addInspectionReport = params =>
  api.post(`/api/InspectionReport`, params);

// 获取质检报告分页列表
export const getInspectionReportList = params =>
  api.get(`/api/InspectionReport`, { params });

// 删除质检报告
export const deleteInspectionReport = id =>
  api.delete(`/api/InspectionReport/${id}`, {});

// 获取质检报告详情
export const getInspectionReportInfo = id =>
  api.get(`/api/InspectionReport/${id}`, {});

// 修改质检报告
export const editInspectionReport = params =>
  api.put(`/api/InspectionReport`, params);

// 获取质检报告下拉（添加质量追溯时使用）
export const getInspectionDropDownList = () =>
  api.get(`/api/InspectionReport/GetDropDownList`, {});

//平板设备管理
export const getEquip = params => api.get(`/api/PadDevice`, { params });
export const addEquip = params => api.post(`/api/PadDevice`, params);
export const deleteEquip = id => api.delete(`/api/PadDevice/${id}`, {});
export const getEdit = id => api.get(`/api/PadDevice/${id}`, {});
export const editEquip = params => api.put(`/api/PadDevice`, params);

/**
 * @method 获取token（timestamp + MD5(timestamp+秘钥) 签名，1分钟内有效）
 */
export const getToken = () => {
  const timestamp = Math.floor(Date.now() / 1000);
  const sign = md5(String(timestamp) + IMG_TOKEN_SECRET);
  return api.get(`/api/Resource/GetImgToken`, { params: { timestamp, sign } });
};

/**
 * @method 获取平台用户分页列表
 */
export const getPlatformUser = params =>
  api.get(`/api/PlatformManage/GetPlatformUserPage`, { params });

/**
 * @method 修改平台用户状态 /api/PlatformManage/UpdatePlatformUserStatus
 */
export const updatePlatformUserStatus = params =>
  api.post(`/api/PlatformManage/UpdatePlatformUserStatus`, params);

/**
 * @method 设置不允许提现时间段
 */
export const setUnWithdrawTime = params =>
  api.post(`/api/PlatformManage/SetUnWithdrawTime`, params);

// 获取不允许提现时间段
export const getUnWithdrawTime = params =>
  api.get(`/api/PlatformManage/GetUnWithdrawTime`, { params });

// 获取基地Id,获取部分塘口数据
export const getPondByFish = id =>
  api.get(`/api/FishBase/GetPondByFishId?id=${id}`, {});

// 获取平台公司分页列表
export const getPlatformEnterprisePage = params =>
  api.get(`/api/PlatformManage/GetPlatformEnterprisePage`, { params });

// 根据员工ID，获取对应员工底下塘口Id和塘口面积
export const getPondListByEmployee = (id, fishBaseId) =>
  api.get(`/api/User/GetPondListByEmployee?EmployeeId=${id}&BaseId=${fishBaseId}`, {});

// 获取所有费用项目
export const getCostTypeV2 = (type) =>
  api.get(`/api/CostSetting/GetCostTypeV2?type=${type}`, {});

export const getCostTypeV3 = (type) =>
  api.get(`/api/CostSetting/GetCostTypeV3?type=${type}`, {});

// 获取整个渔场下塘口列表
export const getAllPondList = () => api.get(`/api/FishPond/GetAllPondList`, {});

//报警联系人列表
export const getAlarmList = () =>
  api.get("/api/EquipmentAlarm/GetAlarmUserDropdownList");

// 修改平台公司认证
export const updatePlatformEnterStatus = (params) => api.post("/api/PlatformManage/UpdatePlatformEnterStatus", params);

// 获取设备列表 按基地塘口分组的引导页
export const getEquipment = (params) => api.get("/api/Equipment", params);

// 获得基地/塘口下的所有设备的数据
export const getEquipmentsData = (params) => api.get("/api/EquipmentSocket/GetEquipmentsData", { params });

// 获取水质参数曲线数据
export const getSensorChartDataDto = (params) => api.post("/api/Equipment/SensorChartDataDto", params);

// 发送尾水监测柜机开始测量命令
export const sendTailWaterMeasureCmd = (params) => api.post("/api/EquipmentSocket/SendTailWaterMeasureCmd", params);

// 获取鱼基地键值对信息
export const getBaseKeyValue = () => api.get("/api/FishBase/KeyValue");

// 获取塘口全览图，可根据基地进行过滤
export const getPongAllView = (params) => api.get("/api/FishPond/GetPongAllView", { params });
